import React, { ReactNode, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from '../../interfaces/app-state';
import { IAppSettings } from '../../interfaces/settings';
import { Layout } from 'antd';
import { Content, Footer } from 'antd/es/layout/layout';
import Logo from '../components/logo/Logo';
import './Static.scss';
import moment from 'moment';

type Props = {
  sideNav?: ReactNode;
  topNav?: ReactNode;
  children: ReactNode;
};
const StaticLayout = ({ children }: Props) => {
  const settings = useSelector<IAppState, IAppSettings>((state) => state.settings);
  const [scrolled, setScrolled] = useState(true);
  const handleScroll = (event) => {
    setScrolled(event.target.scrollTop > 0);
  };
  return (
    <>
      <Layout>
        <Content className='site-layout' style={{ padding: '0 20px' }}>
          <Logo src={'/content/logo.png'} />
          <div className='site-layout-background' style={{ padding: 24, minHeight: 380 }}>
            {children}
          </div>
        </Content>
        <Footer style={{ textAlign: 'center' }}>GESSOMA ©{moment().year()} Creado por Tgestiona</Footer>
      </Layout>
    </>
  );
};
export default StaticLayout;
